import cn from 'classnames';
import { memo, type ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import * as st from './styles.module.scss';

export interface TextInputMPT extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  register?: UseFormRegisterReturn<string>;
  suffix?: ReactNode;
  fullWidth?: boolean;
  validationMessage?: string;
  labelClassName?: string;
  inputClassName?: string;
  firstLetterUppercase?: boolean;
}

export const TextInputM = memo(
  ({
    label,
    error,
    className,
    suffix,
    register,
    fullWidth,
    validationMessage,
    onClick,
    labelClassName,
    inputClassName,
    firstLetterUppercase,
    ...props
  }: TextInputMPT) => {
    return (
      <div className={cn(st.wrapper, className, fullWidth && st.fullWidth)}>
        <input
          className={cn(
            st.input,
            inputClassName,
            firstLetterUppercase && st.firstLetterUppercase,
            !!error && st.input__error
          )}
          onInvalid={(e) =>
            validationMessage && e.currentTarget.setCustomValidity(validationMessage as string)
          }
          onInput={(e) => validationMessage && e.currentTarget.setCustomValidity('')}
          onClick={(e) => {
            e.preventDefault();
            onClick && onClick(e);
          }}
          {...props}
          {...register}
        />

        {label && (
          <label className={cn(st.label, labelClassName)} htmlFor={props.id}>
            {label}
          </label>
        )}

        {suffix && <span className={st.suffix}>{suffix}</span>}
      </div>
    );
  }
);
